import React, { useEffect, useState } from "react";
import { X, Mail } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";

const STORAGE_KEY = "prp_newsletter_dismissed";

export const NewsletterPopup = () => {
    const [open, setOpen] = useState(false);
    const [email, setEmail] = useState("");

    useEffect(() => {
        const dismissed = sessionStorage.getItem(STORAGE_KEY);
        if (!dismissed) {
            const t = setTimeout(() => setOpen(true), 14000);
            return () => clearTimeout(t);
        }
    }, []);

    const close = () => {
        sessionStorage.setItem(STORAGE_KEY, "1");
        setOpen(false);
    };

    const submit = async (e) => {
        e.preventDefault();
        try {
            const res = await api.post("/newsletter", { email });
            toast.success(res.data.message || "Welcome aboard");
            close();
        } catch {
            toast.error("Invalid email");
        }
    };

    if (!open) return null;

    return (
        <div className="fixed bottom-6 right-6 left-6 sm:left-auto sm:right-24 sm:max-w-sm z-[60] animate-in fade-in slide-in-from-bottom-4" data-testid="newsletter-popup">
            <div className="glass-elevated rounded-2xl p-5 neon-border-purple relative">
                <button onClick={close} className="absolute top-3 right-3 text-white/50 hover:text-white" data-testid="newsletter-popup-close" aria-label="Close">
                    <X size={16} />
                </button>
                <div className="flex items-center gap-2 mb-2">
                    <Mail size={14} className="text-[var(--neon-purple)]" />
                    <span className="eyebrow text-[var(--neon-purple)]">Lab Brief</span>
                </div>
                <h4 className="font-display font-bold text-white mb-1">Get 10% off your first order</h4>
                <p className="text-xs text-[var(--text-secondary)] mb-3 leading-relaxed">
                    Receive new releases, COA updates, and lab pricing. No spam.
                </p>
                <form onSubmit={submit} className="flex gap-2">
                    <input
                        type="email"
                        required
                        placeholder="researcher@lab.com"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="flex-1 px-3 py-2 bg-black/40 border border-white/10 rounded-full text-sm text-white placeholder:text-[var(--text-muted)] focus:outline-none focus:border-[var(--neon-purple)]"
                        data-testid="newsletter-popup-email"
                    />
                    <button type="submit" className="px-4 py-2 rounded-full bg-[var(--neon-purple)] text-white text-xs font-bold uppercase tracking-wider" data-testid="newsletter-popup-submit">
                        Join
                    </button>
                </form>
            </div>
        </div>
    );
};
